import RequestService from './request-service';
import MatchesOddsModel from '../models/model-match-odds';
import MatchesOutcomeModel from '../models/model-match-outcome';

/**
 * chnage combi Request Service, used to get odds data data on home page when combi changed from picklist
 */
export default class ChangeCombiService extends RequestService {
  /**
   * Class constructor method
   */
  constructor() {
    super();
    this.endpoint = this.$config.endpoints.matchOddsForMarket;
    this.method = 'get';
    const { Culture } = this.$config.defaultHeaders;
    this.getParams = {
      Culture: Culture,
      MatchData: [],
      OddType: 0,
      Outcomes: []
    };
    this.headers = null;
  }

  mapOdds(oddsList, match) {
    let odd = new MatchesOddsModel(oddsList, match.homeTeam, match.guestTeam);
    odd.outcomes = oddsList.m.map(m => new MatchesOutcomeModel(m, match.homeTeam, match.guestTeam));
    return odd;
  }
}
